import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import measureForm from '../../clients/detail/fbForm/measure/measureForm';
import formatter from '../../common/helpers/formatter';
import type { ClientStatistic } from '../../common/types/statistics/fbStatistics';

type Props = {
  clientStatistics: ClientStatistic;
};

function MeasureStatistics({ clientStatistics }: Props) {
  const measureTypeOptions = formatter.getFieldSelectOptions('type', measureForm.fields);

  return (
    <Stack direction='column' spacing={2}>
      <Typography fontWeight='bold'>Maßnahmen</Typography>
      <Typography>Gesamtanzahl: {clientStatistics.totalNumberOfMeasures}</Typography>

      {Object.keys(clientStatistics.measures).map((key) => {
        const optionByKey = measureTypeOptions.find((option) => option.value === key);

        if (optionByKey == null) {
          return null;
        }
        return (
          <Typography key={key}>
            {optionByKey.label}: {clientStatistics.measures[key]}
          </Typography>
        );
      })}
    </Stack>
  );
}

export default MeasureStatistics;
